var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgToolBox = function SvgToolBox(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.663 4.588h12.675s.975 0 .975.975v7.8s0 .975-.976.975H1.662s-.974 0-.974-.975v-7.8s0-.975.975-.975ZM10.924 4.588a2.925 2.925 0 1 0-5.85 0M.688 8.488h5.85M9.463 8.488h5.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.537 9.138a1.463 1.463 0 0 0 2.925 0v-.78a1.462 1.462 0 1 0-2.925 0v.78Z"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgToolBox);
export default ForwardRef;